import { render, staticRenderFns } from "./DragonpaySuccessPageComponent.vue?vue&type=template&id=12a0c8c4&scoped=true&"
import script from "./DragonpaySuccessPageComponent.vue?vue&type=script&lang=js&"
export * from "./DragonpaySuccessPageComponent.vue?vue&type=script&lang=js&"
import style0 from "./DragonpaySuccessPageComponent.vue?vue&type=style&index=0&id=12a0c8c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a0c8c4",
  null
  
)

export default component.exports